import { array, string, tuple, TupleSchema } from 'yup';

import {
  ConstraintHandlingStrategy,
  ConstraintType,
  IneligibleIfMembershipHasRewardConstraint,
  RewardOfferId,
} from './constraints.types';

export const IneligibleIfMembershipHasRewardConstraintSchema: TupleSchema<IneligibleIfMembershipHasRewardConstraint> =
  tuple([
    string<ConstraintType.IneligibleIfMembershipHasReward>()
      .matches(new RegExp(ConstraintType.IneligibleIfMembershipHasReward))
      .required(),
    string<ConstraintHandlingStrategy>().oneOf(Object.values(ConstraintHandlingStrategy)).required(),
    array(string<RewardOfferId>().required()).required(),
  ])
    .strict()
    .required();
